import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchCursosData = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/cursos`, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};


export const fetchCursosConvocatoriaFilters = async (paginaActual, registrosPorPag, proveedor, nivel,plazas,activo, categoria, subcategoria, busqueda, ordenarColumna, orden) => {
    console.log("nivel", registrosPorPag);
    try {
        const response = await axios.post(`${API_URL}/api/cursos/sepe/filters`, {

            "current_page": paginaActual,
            "items_per_page": registrosPorPag,
            "filteredWord": busqueda,
            "convocatoria": categoria,
            "subcategoriaCurso": subcategoria,
            "proveedor": proveedor,
            "nivel": nivel,
            "plazas": plazas,
            "activo":activo,
            "order": {
                "orderColumn": ordenarColumna || "",
                "order": orden || ""
            }

        }, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});


        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fechtOptenerModelos = async (arrayModelos, arrayAsosiaciones) => {
    try {
        const response = await axios.post(`${API_URL}/api/obtenerDinamico`, {

            "model": arrayModelos,
            "asociacion": arrayAsosiaciones

        }, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});


        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};


export const fetchSubcategorias = async (categoria) => {
    try {

        const response = await axios.post(`${API_URL}/api/categoriasTotales`, {

            categoria: categoria

        }, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});

        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchSoloSubcategorias = async (categoria) => {
    try {

        const response = await axios.get(`${API_URL}/api/soloSubcategorias`, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});

        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};


export const fetchCrearCurso = async (formData) => {
    console.log("formData_feeeee", formData);
    try {
        const response = await axios.post(`${API_URL}/api/crearCurso`, formData, {

            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }

        });


        return response;
    } catch (error) {
        handleAuthError(error);
    }
};


export const fetchEditarCurso = async (formData) => {
    console.log("formData_feeeee", formData);
    try {
        const response = await axios.post(`${API_URL}/api/editarCurso/${formData.IdCurso}`, formData, {

            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }

        });


        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchActualizarCursos = async (ids,campoValor) => {
    console.log("campoValor",campoValor);
    try {
        const response = await axios.post(`${API_URL}/api/actualizarCursosEnCadena`, {
            ids: ids,
            campo: campoValor.atributo,
            valor: campoValor.valor
        }, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});

        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchObtenerCurso = async(id) => {
    try {
        const response = await axios.get(`${API_URL}/api/cursoConvocatoria/obtenerCurso/${id}`, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});

        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};
